import React, { useEffect, useState } from "react";
import FormleftNev from "../../components/common/FormleftNev";
import FormnavBar from "../../components/common/wizard_navbar";
import Lang from "../../lang";
import TlkTable from "../../components/tlelrik/table/tlkTable";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Switch } from "@progress/kendo-react-inputs";
import { Tooltip } from "antd";
import { Button } from "@progress/kendo-react-buttons";
import { Input } from "@progress/kendo-react-inputs";
import queryString from "query-string";
import services from "../../services";
import { toast } from "react-toastify";
import $ from "jquery";
import jsPDF from "jspdf";
import lang from "../../lang";
import Swal from "sweetalert2";
import LabelTabel from "./LabelTable.jsx";
var moment = require("moment");

const dateFormat = "YYYY-MM-DD";
const dateShowFormat = "dd/MM/yyyy";

let imageObj =
    "data:image/png;base64,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";

const InputFieldsAll = {
    Processa_mento: [],
};
let tablesjson = {
    
    detalhesTransferencia: {
        columnKeyMap : {
            selecionarRotulo: "",
                correlativa: "Número de Rotulagem",
                valor: "Valor",
                cor: "Cor",
                teorAlcoolico: "TAV (%)",
                produto: "Produto",
                //ano: "Ano",
                anoProduto: "Ano Produto",
                dataAprovacao : "Data Aprovação",
                acidez: "Acidez volátil (%)",
                mencaoQualitativa: "Menção Qualitativa",
                mencoes: "Menção Complementar",
                anexos: "Imagens",
                
            // observacoesAvaliacao: "Fundamentação da Decisão",
            // capacidade: "Capacidade",
            // cor: "Cor",
            // teorAlcoolico: "Teor Alcoólico",
            // ano: "Ano",
            // anexos: "Anexos"

        },
       // actionbuttons: {TransferenciasRecusa: "Reprovar" , TransferenciasAceita:"Aceitar"},// Redirect: "Emitir Fatura",
        //listApilink: "/Rotulos/GetCorrelativas",
        //requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de fiscalizações pendentes ",
        Filters: {
       
        },
        groupfield: [],
    },
    RotulosNDResumoRegisto: {
        columnKeyMap: {
            numeroRegisto: "Nº de Certificação",
            produto: "Produto",
            cor: "Cor",
            tav: "TAV (%)",
            anoProduto: "Ano",
            mencaoFacultativa: "Menção Facultativa",
            mencaoQualitativa: "Menção Qualitativa",
            mencoes: "Menção Complementar",
            //mencaoObrigatoria: "Menção Obrigatória",
            //nivelQualitativo: "Nível Qualitativo",
            madeira: "Madeira",
            grauDocura: "Grau Doçura",
            acidez: "Acidez volátil (%)"
        },
        //actionbuttons: {AutoButton: "Detalhes" , PdfToo: "pdf" , Desselagem:"Desselagem"},// Redirect: "Emitir Fatura",
        // listApilink: "/ContaCorrente/ViewRegistoProduto",
        // requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de fiscalizações pendentes ",
        Filters: {
       
        },
        groupfield: [],
    },
    RotulosNDResumoRegistoDestino: {
        columnKeyMap: {
            numeroRegisto: "Nº de Certificação",
            produto: "Produto",
            cor: "Cor",
            tav: "TAV (%)",
            anoProduto: "Ano",
            mencaoFacultativa: "Menção Facultativa",
            mencaoQualitativa: "Menção Qualitativa",
            mencoes: "Menção Complementar",
            //mencaoObrigatoria: "Menção Obrigatória",
            //nivelQualitativo: "Nível Qualitativo",
            madeira: "Madeira",
            grauDocura: "Grau Doçura",
            acidez: "Acidez volátil (%)"
        },
        //actionbuttons: {AutoButton: "Detalhes" , PdfToo: "pdf" , Desselagem:"Desselagem"},// Redirect: "Emitir Fatura",
        // listApilink: "/ContaCorrente/ViewRegistoProduto",
        // requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de fiscalizações pendentes ",
        Filters: {
       
        },
        groupfield: [],
    }
}
let listdefaultRequest = {
    Filters: null,
    SortBy: "",
    IsSortTypeDESC: true,
    IsPagination: true,
    Page: 1,
    PageSize: 20,
    idEntidade: null
};
const columnkeyMap = {
    title: Lang.langCheck.langRequest("Title"),
    entity: Lang.langCheck.langRequest("Entity"),
    status: Lang.langCheck.langRequest("Status"),
    observation: Lang.langCheck.langRequest("Observation"),
    attendance: Lang.langCheck.langRequest("Attendance")
}

class DetalhesTranferencias extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            finalDataArray: [],
            show: false,
            isRemarkSet: false,
            mandatoryMissing: false,
            headName: "Transferência de Rótulos",
            sendData: {
                processomento: {
                    pmentos: [],
                },
                processo: {
                    bib: false,
                    seloIncorporado: false,
                    logo: false,
                    macrapropria: false,
                },
                Dataatual: new Date(),
                Ultimaobservacao: "",
                aprovodo: true,
            },
            // readOnly : false,
            readOnly: true,
            parsed: {},
            telkikTable: "",
            entityGrid: "",
            tituloList: [],
            processoTelkikTable: "",
            resData: {},
            registoData: {},
            registoDataTrans: {},
            arrayRegistoProduto:[],
            arrayRegistoProdutoDestino:[],
            filterData: [
                {
                    "Nº Registo": "a",
                    Produto: "a",
                    Cor: "a",
                    Álcool: "a",
                    Tipo: "a",
                    Ano: "a",
                    Doçura: "a",
                    "Acidez (%)": "a",
                    "Saldo Incial (Lts)": "a",
                    Madeira: "a",
                    "Velor energetico": "Velor energetico",
                    Carbohydratos: "Carbohydratos",
                    Proteinas: "Proteinas",
                    "Fibra Elimentor": "Fibra Elimentor",
                    Sodio: "Sodio",
                    "Rotulus aprovados": "xxxxx",
                },
            ],
            nullProcess: true,
        };
    }

    columnlist = Object.keys(columnkeyMap).map(function (key) {
        return { field: columnkeyMap[key], columnMenuType: 'checkbox' }
    }); 

    handleSave = async () => { 
        var codEstadoAprovacao;
        let parsed = queryString.parse(window.location.search);
        if(this.state.sendData.aprovodo == true){
            codEstadoAprovacao = 2
        }else{
            codEstadoAprovacao = 3 
        }
        console.log(
            "save",
            parsed.idPedidoTransferencia , 
            this.state.sendData.Ultimaobservacao,
            codEstadoAprovacao,
            window.localStorage.getItem('username')
        )
        let data = {
            idPedidoTransferencia: parseInt(parsed.idPedidoTransferencia),
            observacoes: this.state.sendData.Ultimaobservacao,
            codEstado: codEstadoAprovacao,
            LoggedUser: window.localStorage.getItem('username')
        };
        console.log(data , "dados no submit")
        let res = await services.apiCall.requestApi(
            "Rotulos/AprovarTransferencias",
            data,
            "post"
        );
        if (res) {
            this.redirectScreen();
        }
    };

    redirectScreen = () => {
        let paramoption = {};
        let url = "";
        if (this.state.parsed.from === "rotulos") {
            url = "/agenda_digital";
            if (this.state.parsed.evaluator == 1) {
                paramoption = {
                    name: "1ª avaliação",
                    url: "/agenda_digital",
                    tableName: "RotulosOneAvalicao",
                };
            } else if (this.state.parsed.evaluator == 2) {
                paramoption = {
                    name: "2ª avaliação",
                    url: "/agenda_digital",
                    tableName: "RotulosTwoAvalicao",
                };
            } else {
                paramoption = {
                    name: "Pendentes",
                    url: "/agenda_digital",
                    tableName: "RotulosPendentes",
                };
            }
        } else if (this.state.parsed.from === "minhas_avaliações") {
            url = "/agenda_digital";
            paramoption = {
                name: "Minhas avaliações",
                url: "/agenda_digital",
                tableName: "minhas_avaliações",
            };
        }
        this.props.history.push({
            pathname: url || "/rotulos",
            state: { paramoption },
        });
    };

    handlePopUpsubmit = (data) => {
        let { finalDataArray } = this.state;
        // finalDataArray=[...finalDataArray,data];
        finalDataArray = [
            ...finalDataArray,
            { discritivo: data.discritivo, titulo: data.id },
        ];
        let tableRowData = { ...data };
        let newData = { ...this.state.sendData };
        newData["processomento"] = { ...newData.processomento };
        newData["processomento"]["pmentos"] = [
            ...newData.processomento.pmentos,
            tableRowData,
        ];
        this.setState(
            {
                sendData: newData,
                show: false,
                finalDataArray,
            },
            () =>
                this.createTabel(
                    "processomento",
                    this.state.sendData.processomento.pmentos
                )
        );
    };

    createPDF = (type) => {
        var doc = new jsPDF("p", "pt", "a4");
        if (type === "Outros Formatos") {
            this.state.resData.imagens &&
                this.state.resData.imagens.map((imageData, i) => {
                    doc.addImage(imageObj, "PNG", 150, 100, 350, 150);
                    if (i < this.state.resData.imagens.length - 1) {
                        doc.addPage();
                    }
                });
            doc.save(type);
        } else if (type === "document") {
            let image =
                this.state.resData &&
                this.state.resData.características_do_rotulo &&
                this.state.resData.características_do_rotulo
                    .documentodecedencia; // use this code but it break so commented for now
            // let image = imageObj
            // doc.addImage(image, 'PNG', 150, 100, 350, 150);
            console.log("image", image);
            var a = document.createElement("a"); //Create <a>
            a.href = "data:image/png;base64," + image; //Image Base64 Goes here
            a.download = "Image.png"; //File name Here
            a.click();
        }
    };

    handleSubmit = async () => {
        // var codEstadoAprovacao;
        // let parsed = queryString.parse(window.location.search);

        //     if(this.state.sendData.aprovodo == true){
        //         codEstadoAprovacao = 2
        //     }else{
        //         codEstadoAprovacao = 3 
        //     }
        //     console.log(
        //         "submit",
        //         parsed.idPedidoTransferencia , 
        //         this.state.sendData.Ultimaobservacao,
        //         codEstadoAprovacao,
        //         window.localStorage.getItem('username')
        //     )
        //     let data = {
        //         idPedidoTransferencia: parseInt(parsed.idPedidoTransferencia),
        //         observacoes: this.state.sendData.Ultimaobservacao,
        //         codEstado: codEstadoAprovacao,
        //         LoggedUser: window.localStorage.getItem('username')
        //     };
            
        //     let res = await services.apiCall.requestApi(
        //         "Rotulos/AprovarTransferencias",
        //         data,
        //         "post"
        //     );
        //     if (res) {
        //         this.redirectScreen();
        //     }
        let parsed = queryString.parse(window.location.search);
        var trasferenciasSelected = $(".tlkTableSizeForRutolosDetail .RotuloCheckClass");
        var filter = []
        for (let index = 0; index < trasferenciasSelected.length; index++) {
            const isChecked = trasferenciasSelected[index].checked;
            if(isChecked == true){
                var idRotulo = parseInt(trasferenciasSelected[index].id.split("RotuloCheck")[1]);
                filter.push(idRotulo)
            }
        }
        let data = {
            idPedidoTransferencia: parsed.idPedidoTransferencia,
            idRotulo: filter,
            idEntidade: parsed.idEntidade
        };
    
        if (filter.length === 0) {
            const { value: motivo } = await Swal.fire({
                title: "Introduza o motivo da recusa",
                input: "text",
                inputPlaceholder: "Escreva o motivo...",
                showCancelButton: true,
                confirmButtonText: "Confirmar",
                cancelButtonText: "Cancelar",
                inputValidator: (value) => {
                    if (!value.trim()) {
                        return "O motivo é obrigatório!";
                    }
                }
            });
    
            if (!motivo) return;
    
            data.motivo = motivo.trim();
        }
    
        console.log("Dados enviados:", data);
    
        let res = await services.apiCall.requestApi(
            "Rotulos/SubmeterRegistoProdutoByTransferencia",
            data,
            "post"
        );
            if (res) {
                this.redirectScreen();
            } 
    };

    // ActionPerform = (action, row) => {
    //     var idRotulo = String(row.idRotulo);
    //     var estado;
    //     var texto;
    //     var pedidoTexto;
    //     if(action == "TransferenciasRecusa"){
    //         estado = false;
    //         texto = "Rótulo reprovado com sucesso"
    //         pedidoTexto ="Deseja reprovar o rótulo?"
    //     }else if(action == "TransferenciasAceita"){
    //         estado = true
    //         texto = "Rótulo aprovado com sucesso"
    //         pedidoTexto ="Deseja aprovar o rótulo?"
    //     }
    //     Swal.fire({
    //         title: pedidoTexto,
    //         showDenyButton: true,
    //         showCancelButton: false,
    //         confirmButtonText: 'Sim',
    //         denyButtonText: 'Não',
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //             (async () => { 
                   
    //                 let data = {
    //                     idRotulo: idRotulo,
    //                     estado: estado
    //                 };
            
    //                 let res = await services.apiCall.requestApi(
    //                     "/Rotulos/ChangeEstadoRotulos",
    //                     data,
    //                     "post"
    //                 );
    //                 if (res) {
    //                       let parsed = queryString.parse(window.location.search);
 
    //                         if (parsed.idPedidoTransferencia) {
    //                             this.getEvaluationData(parsed.idPedidoTransferencia);
    //                         } 
    //                 }
    //             })();
    //         } else if (result.isDenied) {
    //             //this.redirectScreen();
    //         }
    //     })
        //console.log(row , ".......ENCONTRAR IDAUTO")

        // if(action === "PdfToo"){
        //     (async () => {
        //        var Detalhes = row.pdf

        //         this.setState({ invoice: Detalhes });

        //         var file = this.b64toBlob(Detalhes, 'application/pdf');
        //         //If the browser is IE or Edge
        //         if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //             window.navigator.msSaveOrOpenBlob(file);
        //         }
        //         else {
        //             var fileURL = URL.createObjectURL(file);
        //             window.open(fileURL);
        //         }
        //     })();

           
        // }
        // else if(action === "PdfTooFatura"){
        //     (async () => {
        //        var Detalhes = row.pdfFatura

        //         this.setState({ invoice: Detalhes });

        //         var file = this.b64toBlob(Detalhes, 'application/pdf');
        //         //If the browser is IE or Edge
        //         if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //             window.navigator.msSaveOrOpenBlob(file);
        //         }
        //         else {
        //             var fileURL = URL.createObjectURL(file);
        //             window.open(fileURL);
        //         }
        //     })();


     //};
     ActionPerform = () => { };
    createTabel = (type, data) => {
        const columnListTransferencia = Object.keys(tablesjson.detalhesTransferencia.columnKeyMap).map((key) => ({
            field: tablesjson.detalhesTransferencia.columnKeyMap[key],
            columnMenuType: "checkbox",
        }))
        let actionbuttons = tablesjson.detalhesTransferencia.actionbuttons;
        console.log("TesteB ------>",actionbuttons)
        if(data.length > 0){
            data = data[0]
        }
        let telkikTableTransferencia = (
            <TlkTable
                notGroup={true}
                noDownloadButton={true}
                pageable={false}
                date={new Date()}
                notAction={true}
                //actionbuttons={actionbuttons}
                viewFor="detalhesTransferencia"
                forRutoloDetail={true}
                noFilterShow={true}
                modulename="detalhesTransferencia"
                deleteFunc={(id) => this.handleDelete(id)}
                list={data}
                columnlist={columnListTransferencia}
                ActionPerform={(action, id) =>
                    this.ActionPerform(action, id)
                }
            />
        );

        this.setState({ telkikTableTransferencia });
    };
    createTableRegistoDestino = (type, data) => {
        const columnListRegisto = Object.keys(tablesjson.RotulosNDResumoRegistoDestino.columnKeyMap).map((key) => ({
            field: tablesjson.RotulosNDResumoRegistoDestino.columnKeyMap[key],
            columnMenuType: "checkbox",
        }))
        //let actionbuttons = tablesjson.RotulosNDResumoRegisto.actionbuttons;
        //console.log("TestecolumnListRegisto ------>",actionbuttons)
  
                let telkikTableRegistoDestino = (
                    <TlkTable
                        notGroup={true}
                        noDownloadButton={true}
                        pageable={false}
                        date={new Date()}
                        notAction={true}
                        viewFor="RotulosNDResumoRegistoDestino"
                        forRutoloDetail={true}
                        noFilterShow={true}
                        modulename="RotulosNDResumoRegistoDestino"
                        deleteFunc={(id) => this.handleDelete(id)}
                        list={data}
                        columnlist={columnListRegisto}
                        ActionPerform={(action, id) =>
                            this.ActionPerform(action, id)
                        }
                />
                
                );
                this.setState({ telkikTableRegistoDestino });
    };
    createTableRegisto = (type, data) => {
        const columnListRegisto = Object.keys(tablesjson.RotulosNDResumoRegisto.columnKeyMap).map((key) => ({
            field: tablesjson.RotulosNDResumoRegisto.columnKeyMap[key],
            columnMenuType: "checkbox",
        }))
        //let actionbuttons = tablesjson.RotulosNDResumoRegisto.actionbuttons;
        //console.log("TestecolumnListRegisto ------>",actionbuttons)
  
                let telkikTableRegisto = (
                    <TlkTable
                        notGroup={true}
                        noDownloadButton={true}
                        pageable={false}
                        date={new Date()}
                        notAction={true}
                        viewFor="RotulosNDResumoRegisto"
                        forRutoloDetail={true}
                        noFilterShow={true}
                        modulename="RotulosNDResumoRegisto"
                        deleteFunc={(id) => this.handleDelete(id)}
                        list={data}
                        columnlist={columnListRegisto}
                        ActionPerform={(action, id) =>
                            this.ActionPerform(action, id)
                        }
                />
                
                );
                this.setState({ telkikTableRegisto });
    };

    isRemarkSet = () => {
        this.setState({
            isRemarkSet: true,
        });
    };

  
    componentDidMount() {
        $(window).scrollTop(0);
        //this.getTituloList();
        let parsed = queryString.parse(window.location.search);
        console.log("parsed in mount", parsed);
        console.log("PROPS: ", this.props);
        this.setState(
            {
                parsed,
                readOnly: parsed.evaluator ? false : true,
                estado: parsed.estado,
            },

            () => {
                if (parsed.idPedidoTransferencia) {
                    this.getEvaluationData(parsed.idPedidoTransferencia);
                }
            }
        );
    }

    componentDidUpdate(preprops) { }

    getEvaluationData = async (id) => {
        
        
        let dataRegisto = {
            idPedidoTransferencia: id,
        };
        let resRegisto = await services.apiCall.requestApi(
            "/Rotulos/ViewRotulosTransferenciasDetalhe",
            dataRegisto,
            "get"
        );
        let parsed = queryString.parse(window.location.search);
        var estadoQuery = parsed.estado
        if(estadoQuery != "Pendente" && estadoQuery != "Recurso"){
            $(".k-primary").addClass("d-none")
        }
        console.log("response data registo", resRegisto);
        ///teste
        var registo = {"IdPedidosTransferencias": dataRegisto.idPedidoTransferencia};
         let resRegisto2 = await services.apiCall.requestApi(
            "/Rotulos/GetCorrelativasByIdPedidosTransferencias",
            registo,
            "get"
        );
        console.log("teste:",resRegisto2)
        
        let arrayTeste1 = [];
        arrayTeste1.push(resRegisto2);
        let resT = {"idPedidoTransferencia": dataRegisto.idPedidoTransferencia}
        let TransRegisto = await services.apiCall.requestApi(
            "/Rotulos/GetRegistoProduto",
            resT,
            "get"
        );
        console.log("teste:",TransRegisto)
        
        let arrayRegistoProdutoDestino = [];
        if(TransRegisto){
            arrayRegistoProdutoDestino.push(TransRegisto[1])
        }
        
        
        let arrayRegistoProduto = [];
        if(TransRegisto){
            arrayRegistoProduto.push(TransRegisto[0])
        }
        

        let arrayTeste = [];
        arrayTeste.push(resRegisto2);

        var obs = resRegisto.observacoes;
        for (let index = 0; index < resRegisto.length; index++) {
            var numeroPedido = resRegisto[index].numeroPedido;
            var numeroRegistoOrigem = resRegisto[index].numeroRegistoOrigem;
            $("#numeroRegistoOrigem").val(numeroRegistoOrigem)
            $("#numeroRegistoOrigem").text(numeroRegistoOrigem)
            $("#numeroPedido").val(numeroPedido)
            $("#numeroPedido").text(numeroPedido)
            
        }
            this.setState(
                {
                    arrayRegistoProdutoDestino,
                    arrayRegistoProduto,
                    registoDataTrans: arrayTeste,
                    Estado: estadoQuery,
                    Observacoes: obs,
                    //registoData: arrayRegistoProduto,
                },
                () => {
                    this.getTableDate(
                        "Processamento",
                        this.state.registoDataTrans
                    );
                    this.getTableRegistoDestino(
                        "Processamento",
                        this.state.arrayRegistoProdutoDestino
                    );
                    this.getTableRegisto(
                        "Processamento",
                        this.state.arrayRegistoProduto
                    );
                    this.createTabel(
                        "Processamento",
                        this.state.registoDataTrans
                    );
                    this.createTableRegistoDestino(
                        "Processamento",
                        this.state.arrayRegistoProdutoDestino

                    );
                    this.createTableRegisto(
                        "Processamento",
                        this.state.arrayRegistoProduto

                    );
                }
            );

        
    };
    getTableRegisto = (type, data) => {
        //console.log("data Registo: ", data)
        if (type === "Processamento") {
            data.map((el) => {
                Object.keys(tablesjson.RotulosNDResumoRegisto.columnKeyMap).map((key) => {
                
                    if (key === "numeroRegisto") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.numeroRegisto;
                    } 
                    else if (key === "cor") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.cor;
                    } 
                    else if (key === "produto") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.produto;
                    } 
                    else if (key === "tav") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.tav;
                    } 
                    else if (key === "anoProduto") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.anoProduto;
                    } 
                    else if (key === "mencaoFacultativa") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.mencaoFacultativa == "" || el.mencaoFacultativa == undefined  ? "Sem menção" : el.mencaoFacultativa;
                    } 
                    else if (key === "mencaoObrigatoria") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.mencaoObrigatoria;
                    } 
                    else if (key === "nivelQualitativo") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.nivelQualitativo;
                    } 
                    else if (key === "mencaoQualitativa") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.mencaoQualitativa == "" ? "Sem menção" : el.mencaoQualitativa;
                    } 
                    else if (key === "mencoes") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.mencoes == "" ? "Sem menção" : el.mencoes;
                    } 
                    else if (key === "madeira") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.madeira == true ? "Sim" : "Não";
                    }
                    else if (key === "grauDocura") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.grauDocura == "" || el.grauDocura == undefined  ? "Sem doçura" : el.grauDocura;;
                    }
                    else if (key === "acidez") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.acidez;
                    }
                });
            });
        }
    };
    getTableRegistoDestino = (type, data) => {
        //console.log("data Registo: ", data)
        if (type === "Processamento") {
            data.map((el) => {
                Object.keys(tablesjson.RotulosNDResumoRegisto.columnKeyMap).map((key) => {
                
                    if (key === "numeroRegisto") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.numeroRegisto;
                    } 
                    else if (key === "cor") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.cor;
                    } 
                    else if (key === "produto") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.produto;
                    } 
                    else if (key === "tav") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.tav;
                    } 
                    else if (key === "anoProduto") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.anoProduto;
                    } 
                    else if (key === "mencaoFacultativa") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.mencaoFacultativa == "" || el.mencaoFacultativa == undefined  ? "Sem menção" : el.mencaoFacultativa;
                    } 
                    else if (key === "mencaoObrigatoria") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.mencaoObrigatoria;
                    } 
                    else if (key === "nivelQualitativo") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.nivelQualitativo;
                    } 
                    else if (key === "mencaoQualitativa") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.mencaoQualitativa == "" ? "Sem menção" : el.mencaoQualitativa;
                    } 
                    else if (key === "mencoes") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.mencoes == "" ? "Sem menção" : el.mencoes;
                    } 
                    else if (key === "madeira") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.madeira == true ? "Sim" : "Não";
                    }
                    else if (key === "grauDocura") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.grauDocura == "" || el.grauDocura == undefined  ? "Sem doçura" : el.grauDocura;;
                    }
                    else if (key === "acidez") {
                        el[tablesjson.RotulosNDResumoRegisto.columnKeyMap[key]] = el.acidez;
                    }
                });
            });
        }
    };
    getTableDate = (type, data) => {
   
        console.log("data 123: ", data)
        if (type === "Processamento") {
              
               if(data.length > 0){
                data = data[0]
                }
                Object.keys(tablesjson.detalhesTransferencia.columnKeyMap).map((key) => {
                    data.map((el , row,tipo) => {
                     console.log(el)
                     var checkedt;
                     for (let index = 0; index < data.length; index++) { 
                        
                        if (key === "selecionarRotulo") {
                            if(el.aceite == true){
                                checkedt = "true"
                            }else{
                                checkedt = "false"
                            }
                            
                            el[tablesjson.detalhesTransferencia.columnKeyMap[key]] = el.codEstadoTransferencia == 2 && el.aceite == true ?<input type="checkbox"  className="RotuloCheckClass" id={"RotuloCheck"+el.idRotulo} checked disabled></input> : el.codEstadoTransferencia == 2 && el.aceite == false ? <input type="checkbox"  className="RotuloCheckClass" id={"RotuloCheck"+el.idRotulo}  disabled></input> :  <input type="checkbox" className="RotuloCheckClass" id={"RotuloCheck"+el.idRotulo} onClick={(e) =>this.SelectGrid(e)}></input>;
                        }
                        if (key === "correlativa") {
                             
                            el[tablesjson.detalhesTransferencia.columnKeyMap[key]] = el.correlativa;

                        }
                        else if(key === "observacoesAvaliacao"){
                            el[tablesjson.detalhesTransferencia.columnKeyMap[key]] = el.observacoesAvaliacao;
                        }
                        else if(key === "capacidade"){
                            el[tablesjson.detalhesTransferencia.columnKeyMap[key]] = el.capacidade;
                        }
                        else if(key === "cor"){
                            el[tablesjson.detalhesTransferencia.columnKeyMap[key]] = el.cor;
                        }
                        else if(key === "teorAlcoolico"){
                            el[tablesjson.detalhesTransferencia.columnKeyMap[key]] = el.teorAlcoolico;
                        }
                        else if(key === "ano"){
                            el[tablesjson.detalhesTransferencia.columnKeyMap[key]] = el.ano;
                        }
                        else if(key === "valor"){
                            el[tablesjson.detalhesTransferencia.columnKeyMap[key]] = el.valor;
                        }
                        else if(key === "produto"){
                            el[tablesjson.detalhesTransferencia.columnKeyMap[key]] = el.produto;
                        }
                        else if(key === "anoProduto"){
                            el[tablesjson.detalhesTransferencia.columnKeyMap[key]] = el.anoProduto;
                        }
                        else if(key === "mencaoQualitativa"){
                            el[tablesjson.detalhesTransferencia.columnKeyMap[key]] = el.mencaoQualitativa == "" ? "Sem menção" : el.mencaoQualitativa ;
                        }
                        else if(key === "mencoes"){
                            el[tablesjson.detalhesTransferencia.columnKeyMap[key]] =  el.mencoes == "" ? "Sem menção" : el.mencoes ;
                        }
                        else if(key === "dataAprovacao"){
                            var dc = new Date(el.dataAprovacao);
                            var dia = (dc.getDate()) < 10 ? ("0" + dc.getDate()) : (dc.getDate());
                            var mes = (dc.getMonth() + 1) < 10 ? ("0" + (dc.getMonth() + 1)) : (dc.getMonth() + 1);
                            var ano = (dc.getFullYear())
                            var dFormatC = dia + "-" + mes + "-" + ano;

                            el[tablesjson.detalhesTransferencia.columnKeyMap[key]] = dFormatC;
                        }
                        else if(key === "acidez"){
                            el[tablesjson.detalhesTransferencia.columnKeyMap[key]] = el.acidez;
                        }
                        else if(key === "anexos"){
                            var arrayAnexosImagens = [];
                            var item = el.anexos;
                            if(item.length == 0){
                                return ''
                            }else{
                                for (let indexanexo = 0; indexanexo < item.length; indexanexo++) {
                                    var imagem = item[indexanexo].anexo;
                                    var nome = item[indexanexo].nome;
                                  
                                    
                                    var url = item[indexanexo].nome.indexOf('.png') > -1 ? "data:image/png;base64,"+ imagem : "data:application/pdf;base64,"+ imagem;
                                    var d1 = document.getElementById('anexosdiv'); 
                                   
                                    var linhaAnexos =  <button style={{backgroundColor: "transparent" , border: "none" , padding:"0px"}} onClick={(e) =>this.ShowAnexo(e)}   id={url} class={"anexoimage " + nome.replaceAll(' ', '')}><i class="fas fa-file anexosImg" title={nome}></i></button>
                                   
                                    arrayAnexosImagens.push(linhaAnexos)
                                }
                               
                                        
                            return el[tablesjson.detalhesTransferencia.columnKeyMap[key]] = arrayAnexosImagens;
                        }
                            
                    }
                        
                    }
                });
            
            });
        
        }
       
    
    };

    ShowAnexo = (e) => {
       
            var pontos = e.currentTarget.classList[1].split(".");

            if(e.currentTarget.classList[1].split(".")[pontos.length - 1] == "pdf" || e.currentTarget.classList[1].split(".")[pontos.length - 1] == "PDF"){
                var data = e.currentTarget.id.split("data:application/pdf;base64,")[1]
                var byteCharacters = atob(data);
                var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                var byteArray = new Uint8Array(byteNumbers);
                var file = new Blob([byteArray], { type: 'application/pdf;base64' });
                var fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            }else{
                var urlBase =  e.currentTarget.id
                var image = new Image();
                image.src = urlBase;
                var w = window.open("");
                w.document.write(image.outerHTML);
            }
      
    };
    SelectGrid = (e) => {
       console.log(e)
    //    var idRotuloSelecionado = e.currentTarget.id
    //    var parent = $("#"+idRotuloSelecionado)[0].parentElement.parentElement;
    //    $(parent).addClass("k-selected");
    };
    formatTableData = (data) => {
        console.log("formatTableData: ", data)
        return data.map((_row, index) => {
            Object.keys(_row).map(function (key) {
                if (key === "indiceCalorico") {
                    Object.keys(_row[key]).map((_k) => {
                        _row[Lang.langCheck.langRequest(_k)] = _row[key][_k];
                    });
                } else {
                    _row[Lang.langCheck.langRequest(key)] = _row[key];
                }
            });
        });
    };

    // createTable = async (type, data) => {
    //     const columnlist = Object.keys(columnKeyMap).map(function (key) {
    //         return { field: columnKeyMap[key], columnMenuType: "checkbox" };
    //     });

    //     console.log("columnlist", columnlist);
    //     console.log("data", data);


    //     let telkikTable = (
    //         <TlkTable
    //             notGroup={true}
    //             noDownloadButton={true}
    //             pageable={false}
    //             date={new Date()}
    //             notAction={true}
    //             viewFor="marcas"
    //             forRutoloDetail={true}
    //             noFilterShow={true}
    //             modulename="marcas"
    //             deleteFunc={(id) => this.handleDelete(id)}
    //             list={data}
    //             columnlist={columnlist}
    //             ActionPerform={(action, id) =>
    //                 this.ActionPerform(action, id)
    //             }
    //         />
    //     );

    //     this.setState({ telkikTable });
    // }

    returntoFirst = async (obs) => {
        let data = {
            VoltarDoSegundo: true,
            Nprocesso: +this.state.parsed.id,
            Ultimaobservacao: obs,
            NumeroAvaliacao: 2,
            processmentos: {
                Pmentos: [],
            },
        };

        let res = await services.apiCall.requestApi(
            "/SIVDP/evelution_approvel_next_lavel",
            data,
            "post"
        );
        if (res) {
            $("#popup-return").trigger("click");
            let paramoption = {
                name: "1ª avaliação",
                url: "/agenda_digital",
                tableName: "RotulosOneAvalicao",
            };
            this.props.history.push({
                pathname: "/agenda_digital",
                state: { paramoption: paramoption },
            });
        }
    };

    handleLibertar = async () => {
        let res = await services.apiCall.requestApi(
            "/SIVDP/libertar",
            { id: +this.state.parsed.id },
            "post"
        );

        if (res) {
            let paramoption = {
                name: "Pendentes",
                url: "/agenda_digital",
                tableName: "RotulosPendentes",
            };
            this.props.history.push({
                pathname: "/agenda_digital",
                state: { paramoption: paramoption },
            });
        }
    };

    handleChange = (e, type) => {
        console.log("eleeee", e.target.value);
        let sendData = { ...this.state.sendData };
        if (type === "processoLabel") {
            sendData["processo"] = { ...sendData.processo };
            sendData["processo"][e.target.name] = e.target.checked;
        } else {
            // sendData['processomento'] = {...sendData.processomento}
            sendData[e.target.name] =
                type === "date"
                    ? services.Converter.dateConvert(e.target.value, dateFormat)
                    : e.target.value;
        }

        this.setState({ sendData });
    };

    render() {
        // console.log("data",this.state.sendData, this.state.resData)
        console.log("submetidopor:");
        console.log(this.state);
        let leftNavFields = { TransferenciasDet: [], ...InputFieldsAll };
        let parsed = queryString.parse(window.location.search);
        let estadoQuery = parsed.estado;
        let processmentoLabel = this.state.resData.processmentos || {};
        let processoLabel =
            (this.state.resData && this.state.resData.processo) || {};
        console.log(processoLabel);
        return (
            <div className="dashboard">
                {estadoQuery != null ?(
                    <>
                    <FormnavBar
                        showReturnButton={
                            this.state.resData.evaluationStatus !== "under_review1"
                        }
                        pendingCases={
                            this.state.resData.evaluationStatus ===
                            "review2_pending" ||
                            this.state.resData.evaluationStatus ===
                            "under_review2" ||
                            this.state.resData.evaluationStatus === "under_review1"
                        }
                        
                        handleLibertar={() => this.handleLibertar()}
                        handleSave={() => this.handleSave()}
                        to={"/" + (this.state.parsed.from || "rotulos")}
                       handleSubmit={(data, url) => this.handleSubmit(data, url)}
                        returntoFirst={(data) => this.returntoFirst(data)}
                        estado={this.state.resData.estado}
                        numeroAvaliacao={this.state.resData.numeroAvaliacao}
                        parsed={this.state.parsed}
                        type="parcelas"
                        headName="Trasf"
                        evaluator={
                            this.state.resData.evaluationStatus ===
                            "review2_pending" ||
                            this.state.resData.evaluationStatus ===
                            "under_review2" ||
                            this.state.resData.evaluationStatus === "under_review1"
                        }
                    />
                    </>
                ):(
                    <>
                    <FormnavBar
                        showReturnButton={
                            this.state.resData.evaluationStatus !== "under_review1"
                        }
                        pendingCases={
                            this.state.resData.evaluationStatus ===
                            "review2_pending" ||
                            this.state.resData.evaluationStatus ===
                            "under_review2" ||
                            this.state.resData.evaluationStatus === "under_review1"
                        }
                        
                        handleLibertar={() => this.handleLibertar()}
                        handleSave={() => this.handleSave()}
                        to={"/" + (this.state.parsed.from || "agenda_digital")}
                        handleSubmit={(data, url) => this.handleSubmit(data, url)}
                        returntoFirst={(data) => this.returntoFirst(data)}
                        estado={this.state.resData.estado}
                        numeroAvaliacao={this.state.resData.numeroAvaliacao}
                        parsed={this.state.parsed}
                        type="parcelas"
                        headName={this.state.headName}
                        evaluator={
                            this.state.resData.evaluationStatus ===
                            "review2_pending" ||
                            this.state.resData.evaluationStatus ===
                            "under_review2" ||
                            this.state.resData.evaluationStatus === "under_review1"
                        }
                    />
                    </>
                )}
               
                <div className="full-container edit-ward">
                    <FormleftNev
                        InputFieldsAll={leftNavFields}
                        navFor="Rotulo"
                    />
                    <div className="right-section right-section-processo">
                        <div className="row top-serch">
                           
                            {this.state.parsed ? (
                                <div
                                    className="bg-white middle p20"
                                    id="TransferenciasDet"
                                >
                                    <div className="head">
                                        <h2>
                                            {Lang.langCheck.langRequest(
                                                "Detalhe da Transferência"
                                            )}
                                        </h2>
                                        <p className="font-14"></p>
                                        <div className="row mt-3">
                                            <div className="col-md-4">
                                                <label class="rotulos_head mb-0">
                                                Nº de Pedido
                                                </label>
                                                <br />
                                                <label className="rotulos_content">
                                                <div id="numeroPedido"></div>
                                                </label>
                                            </div>
                                            <div className="col-md-4">
                                                <label class="rotulos_head mb-0">
                                                Nº de Certificação de Origem
                                                </label>
                                                <br />
                                                <label className="rotulos_content">
                                                <div id="numeroRegistoOrigem"></div>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="row mt-3">
                                        <p className="font-14"></p>
                                        <div className="col-md-4">
                                                <label class="rotulos_head mb-0">
                                                Resumo da Certificação de Destino
                                                </label>
                                                <br />
                                                
                                            </div>
                                        </div>
                                        <p className="font-14"></p>

                                        {this.state.telkikTableRegistoDestino}

                                        <div className="row mt-3">
                                        <p className="font-14"></p>
                                        <div className="col-md-4">
                                                <label class="rotulos_head mb-0">
                                                Resumo da Certificação de Origem
                                                </label>
                                                <br />
                                                
                                            </div>
                                        </div>
                                        <p className="font-14"></p>

                                        {this.state.telkikTableRegisto}
                                        <p className="font-14"></p>
                                        <div class="alert alert-info" role="alert">
                                            <i class="fas fa-info" style={{marginRight: "5px"}}></i>Os items selecionados na grid serão aprovados ao submeter.
                                        </div>
                                        {this.state.telkikTableTransferencia}
                                    </div>
                                </div>
                            ) : (
                                <>
                                    
                                </>
                            )}
                            
                            {this.state.estado === "Sob Análise" ? (
                                ""
                            ) : (
                                <div
                                    className="bg-white middle p20 position-relative"
                                    id="Processa_mento"
                                >
                                    <div className="head position-relative mb-4">
                                        <h2>
                                            {Lang.langCheck.langRequest(
                                                "Processamento"
                                            )}
                                        </h2>
                                        {this.state.mandatoryMissing &&
                                            !this.state.isRemarkSet &&
                                            this.state.nullProcess && (
                                                <span
                                                    className="text-danger"
                                                    style={{
                                                        marginTop: "-10px",
                                                    }}
                                                >
                                                    Campo obrigatório
                                                </span>
                                            )}
                                    </div>
                                    <div>
                                        {
                                            // this.state.sendData && this.state.sendData.processomento &&
                                            this.state.processoTelkikTable
                                        }
                                    </div>
                                    {this.state.parsed.view ? (
                                        <> 
                                        </>
                                    ) :(
                                        <>
                                        {estadoQuery != null ?(
                                             <> 
                                            <div className={"row"}>
                                                <div className={"col-md-3"}>
                                                    <label className="rotulos_head mb-0">
                                                        Estado
                                                    </label>
                                                    <br />
                                                    <label className="rotulos_content">
                                                        {this.state.Estado}
                                                    </label>
                                                </div>
                                                {/* <div className={"col-md-12"}>
                                                    <label className="rotulos_head mb-0">
                                                        Observações
                                                    </label>
                                                    <br />
                                                    <label className="rotulos_content">
                                                        {this.state.Observacoes}
                                                    </label>
                                                </div> */}
                                            </div>
                                            </>
                                        ):(

                                            <> 
                                            <div
                                                className={
                                                    "row align-items-center"
                                                }
                                            >
                                                <div className="{col-md-9}">
                                                    <div className="input-box active-grey mt20">
                                                        <Switch
                                                            id="switch1"
                                                            name="aprovodo"
                                                            className="ml-4"
                                                            onLabel=""
                                                            offLabel=""
                                                            checked={
                                                                this.state
                                                                    .sendData
                                                                    .aprovodo
                                                            }
                                                            style={{
                                                                width: "100%",
                                                            }}
                                                            onChange={(e) =>
                                                                this.handleChange(
                                                                    e,
                                                                    "toggle"
                                                                )
                                                            }
                                                        />
                                                        <label class="z-index-9 pl-4">
                                                            {" "}
                                                            <span className="circle-green"></span>
                                                            Aprovar /{" "}
                                                            <span className="circle-red"></span>
                                                            Recusar
                                                        </label>
                                                    </div>
                                                </div>
                                            
                                            </div>
                                            <div className={"row mt-2"}>
                                                <div className={"col-md-12"}>
                                                    <div className="input-box active-grey">
                                                        <label className="input-label">
                                                            Observações
                                                        </label>
                                                        <textarea
                                                            name="Ultimaobservacao"
                                                            value={
                                                                this.state
                                                                    .sendData
                                                                    .Ultimaobservacao
                                                            }
                                                            onChange={(e) =>
                                                                this.handleChange(
                                                                    e,
                                                                    "text"
                                                                )
                                                            }
                                                            className={
                                                                "form-control heigh-auto mt-2"
                                                            }
                                                        ></textarea>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            </>
                                        )}
                                        </>
                                    )}
                                  
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DetalhesTranferencias;
